import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';

export default function () {
  const downloadPdfButton = document.querySelector('.download_work_pdf_button2');

  if (!downloadPdfButton) {
    return;
  }

  const statusWrapper = document.querySelector('.action-status-messages');

  downloadPdfButton?.addEventListener('click', async function (e) {
    const button = e.currentTarget;
    const url = button.getAttribute('data-url');

    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {
        },
      }
    );
    const result = await response.json();

    if (result.status == 'success') {
      const workHtmlToPdfBlock = document.querySelector('#work-pdf-html');
      workHtmlToPdfBlock.innerHTML = result.html;

      const opt = {
        margin: 10,
        filename: `test-pdf.pdf`,
        image: { type: 'png', quality: 1.00 },
        html2canvas: { scale: 1, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all' }
      }

      // Генерируем и скачиваем PDF
      var worker = html2pdf();
      worker
        .set(opt)
        .from(result.html)
        .toPdf()
        .get('pdf')
        .save()
      ;
    } else {

    }
  });
}